var utils = require("../../utils/utils");
var createTasksFacade = require("./datastore_tasks"),
	createLinksFacade = require("./datastore_links"),
	DataStore = require("../datastore/datastore"),
	TreeDataStore = require("../datastore/treedatastore");
var datastoreRender = require("../datastore/datastore_render");

function getDatastores(){
	var storeNames = this.$services.getService("datastores");
	var res = [];
	for(var i = 0; i < storeNames.length; i++){
		res.push(this.getDatastore(storeNames[i]));
	}
	return res;
}

var createDatastoreFacade = function(){
	return {
	createDatastore: function(config){

		var $StoreType = (config.type || "").toLowerCase() == "treedatastore" ? TreeDataStore : DataStore;

		var store = new $StoreType({
			initItem: config.initItem
		});

		if(config.name){

			this.$services.setService("datastore:" + config.name, function(){return store;});
			var storeList = this.$services.getService("datastores");
			if(!storeList){
				storeList = [];
				this.$services.setService("datastores", function(){return storeList;});
			}
			storeList.push(config.name);

			datastoreRender.bindDataStore(config.name, this);
		}

		return store;
	},
	getDatastore: function(name){
		return this.$services.getService("datastore:" + name);
	},

	refreshData: function () {
		var stores = getDatastores.call(this);
		for(var i = 0; i < stores.length; i++){
			stores[i].refresh();
		}
	},

	isChildOf: function(childId, parentId){
		return this.$data.tasksStore.isChildOf(childId, parentId);
	},

	refreshTask: function (taskId, refresh_links) {
		var task = this.getTask(taskId);
		if (task && this.isTaskVisible(taskId)) {
			this.$data.tasksStore.refresh(taskId);

			if (refresh_links !== undefined && !refresh_links)
				return;
			for (var i = 0; i < task.$source.length; i++) {
				this.refreshLink(task.$source[i]);
			}
			for (var i = 0; i < task.$target.length; i++) {
				this.refreshLink(task.$target[i]);
			}
		}

	},
	refreshLink: function (linkId) {
		this.$data.linksStore.refresh(linkId);
	},

	silent: function(code){
		var gantt = this;
		gantt.$data.tasksStore.silent(function(){
			gantt.$data.linksStore.silent(function(){
				code();
			});
		});
	},
	sort: function (field, desc, parent, silent) {
		var render = !silent;//4th argument to cancel redraw after sorting

		if (!this.isTaskExists(parent)) {
			parent = this.config.root_id;
		}

		if (!field) field = "order";
		var criteria = (typeof(field) == "string") ? (function (a, b) {
			if (a[field] == b[field]) {
				return 0;
			}

			var result = a[field] > b[field];
			return result ? 1 : -1;
		}) : field;

		if (desc) {
			var original_criteria = criteria;
			criteria = function (a, b) {
				return original_criteria(b, a);
			};
		}

		var els = this.getChildren(parent);
		if (els) {
			var temp = [];
			for (var i = els.length - 1; i >= 0; i--)
				temp[i] = this.$data.tasksStore.getItem(els[i]);

			temp.sort(criteria);

			for (var i = 0; i < temp.length; i++) {
				els[i] = temp[i].id;
				this.sort(field, desc, els[i], true);
			}
		}

		if (render) {
			this.render();
		}
	},
	clearAll: function () {
		var stores = getDatastores.call(this);
		for(var i = 0; i < stores.length; i++){
			stores[i].clearAll();
		}

		this._update_flags();
		this.userdata = {};
		this.callEvent("onClear", []);
		this.render();
	},
	_clear_data: function () {
		this.$data.tasksStore.clearAll();
		this.$data.linksStore.clearAll();
		this._update_flags();
		this.userdata = {};
	},

	_has_children: function (id) {
		return this.getChildren(id).length > 0;
	}
};
};

function createFacade(){
	var res = utils.mixin({}, createDatastoreFacade());
	utils.mixin(res, createTasksFacade());
	utils.mixin(res, createLinksFacade());
	return res;
}




module.exports = {create: createFacade};


//////////////////
// WEBPACK FOOTER
// ./sources/core/facades/datastore.js
// module id = 53
// module chunks = 0